import { Component } from '@angular/core';
import { ConfigService } from './config.service';

@Component({
  selector: 'app-root',
  templateUrl: 'app.component.html',
  styleUrls: ['app.component.scss'],
})
export class AppComponent {
  
  public appPages;
  public hideBPspecificPages: Boolean;

  constructor(private configService: ConfigService) {}

  async ngOnInit() {
    let res = await this.configService.getConfiguration();
    this.hideBPspecificPages = res["hideBPspecificPages"];

    if(this.hideBPspecificPages) {
      this.appPages = [
        {
          title: 'Elections',
          url: '/elections',
          icon: 'home'
        },
        {
          title: 'Ballot',
          url: '/ballot',
          icon: 'checkbox'
        },
        {
          title: 'Address',
          url: '/address',
          icon: 'pin'
        }
    
      ];
    } else {
      this.appPages = [
        {
          title: 'Elections',
          url: '/home',
          icon: 'home'
        },
        {
          title: 'Ballot',
          url: '/ballot',
          icon: 'checkbox'
        },
        {
          title: 'Address',
          url: '/address',
          icon: 'pin'
        },
        {
          title: 'Share',
          url: '/share',
          icon: 'share'
        },
        {
          title: 'Info',
          url: '/info',
          icon: 'information-circle'
        },
        {
          title: 'FAQ',
          url: '/faq',
          icon: 'help-circle'
        },
        {
          title: 'Donate',
          url: '/donate',
          icon: 'pricetag'
        },
        {
          title: 'Subscribe',
          url: '/subscribe',
          icon: 'mail'
        },
        {
          title: 'Feedback',
          url: '/feedback',
          icon: 'send'
        },
        {
          title: 'Privacy Policy',
          url: '/privacy',
          icon: 'lock-closed-outline'
        }
    
      ];
    }
  }

}
